"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvStringList = exports.getEnvNumberList = exports.getEnvJson = exports.getEnvBoolean = exports.getEnvString = exports.getEnvNumber = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
const ParserUtils_1 = require("./ParserUtils");
function handleParsingError(ctx, err, variableName, defaultValue) {
    if (defaultValue !== undefined) {
        commons_logs_1.log.error(Object.assign(Object.assign({}, ctx), { err }), "Unable to parse environment variable, returning the default value instead");
        return defaultValue;
    }
    else {
        commons_logs_1.log.error(Object.assign(Object.assign({}, ctx), { err }), "Unable to parse environment variable and no default was provided. Throwing an error.");
        throw new Error(`Error parsing ENV var ${variableName}`);
    }
}
function getEnvWithParser(variableName, parser, defaultValue) {
    const envString = process.env[variableName];
    const ctx = { fn: "getEnv", variableName, envString, defaultValue };
    if (envString) {
        try {
            return parser(envString);
        }
        catch (error) {
            return handleParsingError(ctx, error, variableName, defaultValue);
        }
    }
    if (defaultValue !== undefined) {
        return defaultValue;
    }
    else {
        throw new Error(`Missing ENV var ${variableName} and no default was provided.`);
    }
}
const getEnvNumber = (name, defaultValue) => getEnvWithParser(name, ParserUtils_1.finiteNumber, defaultValue);
exports.getEnvNumber = getEnvNumber;
const getEnvString = (name, defaultValue) => getEnvWithParser(name, ParserUtils_1.nonemptyString, defaultValue);
exports.getEnvString = getEnvString;
const getEnvBoolean = (name, defaultValue) => getEnvWithParser(name, ParserUtils_1.bool, defaultValue);
exports.getEnvBoolean = getEnvBoolean;
const getEnvJson = (name, defaultValue) => getEnvWithParser(name, ParserUtils_1.json, defaultValue);
exports.getEnvJson = getEnvJson;
const getEnvNumberList = (name, defaultValue) => getEnvWithParser(name, (0, ParserUtils_1.listOf)(ParserUtils_1.finiteNumber), defaultValue);
exports.getEnvNumberList = getEnvNumberList;
const getEnvStringList = (name, defaultValue) => getEnvWithParser(name, (0, ParserUtils_1.listOf)(ParserUtils_1.nonemptyString), defaultValue);
exports.getEnvStringList = getEnvStringList;
//# sourceMappingURL=EnvUtils.js.map